module.exports = __webpack_public_path__ + "img/chinesecompany98.7acc2813.png";